import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useMultiplexListingFlow } from '../../hooks';
import { RMWContext } from '../../providers/RMWContext';
import { AppSelectors, PropertiesSelectors } from '../../selectors';
import accessUtils from '../../utils/accessUtils';

import * as RouteConstants from '../../constants/RouteConstants';
import StringConstants from '../../constants/StringConstants';

const propTypes = {
  route: PropTypes.oneOf(Object.values(RouteConstants)).isRequired,
  location: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

const defaultProps = {};

const PermissionCheck = ({ route, location, children }) => {
  const user = useSelector((state) => state.user);
  const cookieEnabledServices = useSelector((state) => AppSelectors.makeCookieEnabledServices(state));
  const currentProperty = useSelector((state) => PropertiesSelectors.makeCurrentProperty(state));
  const brand = useSelector((state) => AppSelectors.makeBrand(state));
  const isRunningInProd = useSelector((state) => AppSelectors.makeIsRunningInProd(state));

  const { paths } = useContext(RMWContext);

  const { isInMultiplexListingFlow } = useMultiplexListingFlow();

  const canAccessCreateListingWithFeatureFlag = accessUtils.canAccessModularListing({
    currentProperty,
    user,
  });

  const canAccessRentGuaranteeWithFeatureFlag = accessUtils.canAccessRentGuaranteeWithFeatureFlag({
    cookieEnabledServices,
  });

  const { pathname } = location;
  const redirectTo = {
    [RouteConstants.PDP_PAYMENTS]:
      !user.paymentsAccessAllowed && pathname.replace(paths.propertyDetailsPayments, paths.propertyDetailsListing),
    [RouteConstants.PDP_APPLICATIONS]:
      brand !== StringConstants.UNFORMATTED_BRAND_NAMES.zillow &&
      pathname.replace(paths.propertyDetailsApplications, paths.propertyDetailsListing),
    [RouteConstants.USER_MANAGEMENT_PAGE]:
      !accessUtils.canAccessUserManagement({ user, cookieEnabledServices }) && paths.propertiesPage,
    [RouteConstants.USER_MANAGEMENT_APPLICATION_PERMISSION_PAGE]:
      !accessUtils.canAccessUserManagementApplicationPermission({ user }) && paths.userManagementPage,
    [RouteConstants.ANALYTICS_PAGE]:
      !accessUtils.canAccessGlobalAnalytics({ user, cookieEnabledServices }) && paths.propertiesPage,
    [RouteConstants.INVOICE_PAYMENTS]: !accessUtils.canAccessInvoicePayments({ user }) && paths.propertiesPage,
    [RouteConstants.RENT_GUARANTEE_ENROLL_PATH]: !canAccessRentGuaranteeWithFeatureFlag && paths.propertiesPage,
    [RouteConstants.EXPERIMENTS_PATH]: isRunningInProd ? !user.isPostingPathAdmin && paths.propertiesPage : false,
    [RouteConstants.CREATE_LISTING_PAGE]:
      !canAccessCreateListingWithFeatureFlag && !isInMultiplexListingFlow && paths.propertiesPage,
  };

  return redirectTo[route] ? <Redirect to={redirectTo[route]} /> : children;
};

PermissionCheck.propTypes = propTypes;
PermissionCheck.defaultProps = defaultProps;

export { PermissionCheck };
export default withRouter(PermissionCheck);
